import { Button, Checkbox, DatePicker, Input, Tooltip } from "antd";
import { FixedSizeList as List } from "react-window";
import { useState } from "react";
import styles from "./styles.module.scss";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;

const CheckboxFilter = ({
  filters,
  onApplyFilter,
  onReset,
  type,
  columnName,
}: {
  filters: any[];
  onApplyFilter: (value: any[] | null) => void,
  onReset: () => void;
  columnName: string;
  type: string;
}) => {
  const [searchValue, setSearchValue] = useState("");
  const [selectedValues, setSelectedValues] = useState<any[]>([]);
  const [searchRange, setSearchRange] = useState<[string, string] | null>(null);

  const isDatetime = type === "datetime";

  const filteredOptions = isDatetime
    ? filters
    : filters.filter(filter => filter.text.toLowerCase().includes(searchValue.toLowerCase()));

  const itemHeight = 35;
  const listHeight = Math.min(filteredOptions.length * itemHeight, 200);

  return (
    <div
      style={{
        width: "100%",
        padding: "8px",
        display: "flex",
        flexDirection: "column",
      }}
    >

      {isDatetime ? (
        <RangePicker
          value={searchRange ? [dayjs(searchRange[0]), dayjs(searchRange[1])] : null}
          style={{ marginBottom: "8px", width: "100%" }} 
          onChange={(dates) => {
            if (dates) {
              setSearchRange([dates[0]?.toISOString() ?? "", dates[1]?.toISOString() ?? ""]);
            } else {
              setSearchRange(null);
            }
          }}
        />
      ) : (
        <>
          <Input.Search
            value={searchValue}
            placeholder={`Search ${columnName} ...`}
            style={{ marginBottom: "8px", width: "100%" }}
            onChange={(e) => setSearchValue(e.target.value)}
          />
          <Checkbox.Group value={selectedValues} onChange={setSelectedValues}>
            <List
              height={listHeight}
              itemCount={filteredOptions.length}
              itemSize={itemHeight}
              width="100%"
            >
              {({ index, style }) => (
                <div style={style}>
                  <Checkbox
                    value={filteredOptions[index].value}
                    className={styles.checkbox}
                  >
                    <Tooltip placement="top" title={filteredOptions[index].value}>
                      <span
                        style={{
                          display: "inline-block",
                          maxWidth: "160px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {filteredOptions[index].text}
                      </span>
                    </Tooltip>
                  </Checkbox>
                </div>
              )}
            </List>
          </Checkbox.Group>
        </>
      )}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "8px",
        }}
      >
        <Button
          onClick={() => {
            setSearchValue("");
            setSearchRange(null);
            setSelectedValues([]);
            onReset();
          }}
          disabled={!searchValue && !searchRange && !selectedValues.length}
          style={{ border: "none" }}
        >
          Reset
        </Button>
        <Button type="primary" onClick={() => onApplyFilter(isDatetime ? searchRange : selectedValues)}>
          OK
        </Button>
      </div>
    </div>
  );
};

export default CheckboxFilter;
